'use strict';

export class Cookie {
	
	static getCookie(name) {
		let matches = document.cookie.match(new RegExp(
			"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		
		return matches ? decodeURIComponent(matches[1]) : null;
	}
	
	static setCookie(name, value, options = {}) {
		// localStorage.setItem(name,value);
		
		options = {
			path: '/',
			...options
		};
		
		if (options.expires instanceof Date) {
			options.expires = options.expires.toUTCString();
		}
		
		let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
		
		for (let optionKey in options) {
			updatedCookie += "; " + optionKey;
			let optionValue = options[optionKey];
			if (optionValue !== true) {
				updatedCookie += "=" + optionValue;
			}
		}
		
		document.cookie = updatedCookie;
	}
	
	static userData() {
		const data = Cookie.getCookie('userData');
		return data ? JSON.parse(data) : null;
	}
	
	static addToUserData(key,value,update = false) {
		let data = Cookie.userData();
		if (!data) {
			data = {};
		}
		
		if (typeof key === 'object') {
			Object.entries(key).forEach(([dataKey,dataValue]) => {
				if (update) {
					if (dataValue) {
						data[dataKey] = dataValue;
					}
				} else {
					data[dataKey] = dataValue;
				}
			});
		} else {
			if (update) {
				if (value) {
					data[key] = value;
				}
			} else {
				data[key] = value;
			}
		}
		
		Cookie.setCookie('userData',JSON.stringify(data));
	}
	
	static getFromUserData(key) {
		const data = Cookie.userData();
		return data ? data[key] : null;
	}
	
	static removeFromUserData(key) {
		const data = Cookie.userData();
		if (data && data[key]) {
			delete data[key];
			Cookie.setCookie('userData',JSON.stringify(data));
		}
	}
	
	static parse() {
		return document.cookie
			.split(';')
			.map(v => v.split('='))
			.reduce((acc,v) => {
				acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
				return acc;
			},{})
	}
}
